import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';



import { UsersService, 
  AuthService, DittaService, 
  Ditta, Users} from 'my-lib-sanfelici';

@Component({
  selector: 'app-ditta-details',
  templateUrl: './ditta-details.component.html',
  styleUrls: ['./ditta-details.component.scss']
})
export class DittaDetailsComponent implements OnInit {
id: string;
user: Observable<Users>;
ditta: Observable<Ditta>;
  constructor(
    private authservice: AuthService,

    private db: AngularFirestore,
    private router: Router,
    private route: ActivatedRoute,
    private dittaservice: DittaService,
    private usersservice: UsersService) { }
cancella(id){
  this.dittaservice.delete(id).then(() => {
this.router.navigate(['/myuser', 'ditta',  'details', id]);
  });
}
  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.user = this.usersservice.details(this.id);
    this.ditta = this.dittaservice.get(this.id);
    this.ditta.subscribe(d=>{
if(d){}else{
  this.router.navigate(['/myuser', 'ditta',  'create', this.id]);
}
    });
      }

}
